import { Button, LoadingSpinner } from '@idexx-laboratories/spot-react';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Grid from '../../components/Grid/Grid';
import { LoadingSpinnerWithContent } from '../../components/LoadingSpinnerWithContent/LoadingSpinnerWithContent';
import { useStore } from '../../hooks/use-store';
import { isDefined } from '../../utils/object-utils';
import './PracticeUserManagement.scss';

const PracticeUserManagement = observer(() => {
  const navigate = useNavigate();
  const { practiceUserManagementStore: store, globalStore } = useStore();
  const { colDefs, users, loaders } = store;

  useEffect(() => {
    if (!store.sapId) {
      navigate('/');
      return;
    }
    void store.init();
  }, [navigate, store, store.sapId]);

  if (loaders.page)
    return (
      <LoadingSpinnerWithContent size='large'>
        One moment while we retrieve your practice users
      </LoadingSpinnerWithContent>
    );

  return (
    <div className='practice-user-management-wrapper'>
      <div className='spot-typography__heading--level-2'>
        Manage Users for{' '}
        <span title={globalStore.selectedSap.name}>{globalStore.selectedSap.id}</span>
      </div>
      <div className='spot-typography__text--tertiary'>
        Create and manage users, including role assignments, for your practice&apos;s MyCornerstone
        account. Only Practice Admin role users can manage portal users.
        <br />
        For each portal user, use the same email address that is registered with their MyIDEXX
        account.
      </div>
      <Button
        className='add-more-btn'
        aria-label='Add More'
        variant='link'
        size='small'
        iconLeft='plus'
        disabled={loaders.user}
        onClick={() => store.addUser()}
      >
        Add Users
      </Button>
      {loaders.user && <LoadingSpinner />}
      <Grid id='practice-users-management-grid' columns={colDefs} data={users} />

      <div className='horizontal-flex-box practice-user-management_actions'>
        <Button
          className='back item-editors'
          variant='link'
          size='small'
          onClick={() => store.back()}
        >
          Back
        </Button>
        <div className='main-buttons'>
          <Button
            variant='primary'
            size='small'
            disabled={loaders.user || isDefined(store.currentIndex)}
            onClick={() => store.done()}
          >
            Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
});

export default PracticeUserManagement;
